import React from 'react';
import { Poppins, Spacer } from 'src/common';
import { BaseCard } from '../../styled';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { CashPlaceholder } from '../comps';
import { numeralFormat } from 'src/utils/misc';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;

    &__item {
      /* height: 52px; */
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

interface ExpectedLossProps {
  value: DashboardQuery['dashboard']['expectedLoss'];
  state: AssessmentState;
}

export const ExpectedLoss: React.FC<ExpectedLossProps> = ({ value, state }) => {
  return (
    <Wrap>
      <span className="c-title">Expected Loss</span>

      <div className="content">
        <span className="description">
          The assessment expected loss represents the probability adjusted, mean loss if each risk were to manifest in
          the same year.
        </span>
      </div>
      <div style={{ flex: 1 }} />

      {state === 'NO_SCENARIOS' ||
      state === 'ALL_INFO_AVAILABLE' ||
      state === 'SCENARIOS_LIVE_CONTROLS_MODIFIERS' ||
      state === 'SCENARIOS_PENDING_CONTROLS_MODIFIERS' ? (
        <div className="grid">
          <div className="grid__item">
            <Poppins px={12} weight={500}>
              UNMODIFIED
            </Poppins>
            <Spacer $px={6} />

            {state === 'NO_SCENARIOS' ? (
              <CashPlaceholder state={state} />
            ) : (
              <Poppins weight={600} px={26} className="value">
                {numeralFormat(value?.unmodifiedRisk)}
              </Poppins>
            )}
          </div>
          <div className="grid__item">
            <Poppins px={12} weight={500}>
              LIVE
            </Poppins>
            <Spacer $px={6} />

            {state === 'NO_SCENARIOS' ? (
              <CashPlaceholder state={state} />
            ) : (
              <Poppins weight={600} px={26} className="value" color="gp1">
                {numeralFormat(value?.liveRisk)}
              </Poppins>
            )}
          </div>
          <div className="grid__item">
            <Poppins px={12} weight={500}>
              PROJECTED
            </Poppins>
            <Spacer $px={6} />

            {state === 'NO_SCENARIOS' ? (
              <CashPlaceholder state={state} />
            ) : (
              <Poppins weight={600} px={26} className="value" color="brightBlue">
                {numeralFormat(value?.projectedRisk)}
              </Poppins>
            )}
          </div>
        </div>
      ) : (
        <Poppins weight={600} px={26} className="value" color="gp1">
          {numeralFormat(value?.unmodifiedRisk)}
        </Poppins>
      )}
    </Wrap>
  );
};
